import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import ApiRouter from '../util/router';
@NgModule({
    declarations: [
    ],
    imports: [
        IonicModule,
        CommonModule
    ],
    exports:[
    ]
})
export class HttpModule{
    constructor(private http:HttpClient){}
    request(router,params){
        return new Promise((resolve,reject)=>{
            Object.keys(params).forEach(item=>{
                router.url = router.url.replace(`{${item}}`,params[item])
            })
            if(router.method=="POST"){
                this.http.post(router.url,params)
                    .subscribe(
                        res=>{
                            resolve(res)
                        },
                        err=>{
                            if(err.status==500){
                                let usrstr = localStorage.getItem("user")
                                let usr = JSON.parse(usrstr)
                                this.http.post(ApiRouter.refreshToken.url,{token:usr.token,refreshToken:usr.refreshToken})
                                    .subscribe(
                                        (refreshRes:any)=>{
                                        usr.token = refreshRes.data.token
                                        usr.refreshToken = refreshRes.data.token
                                        localStorage.setItem("user",JSON.stringify(usr))
                                        this.http.post(router.url,params)
                                            .subscribe(
                                                newRes=>{
                                                    resolve(newRes)
                                                },
                                                newErr=>{
                                                    reject(err)
                                                }
                                            )
                                    })
                            }else{
                                reject(err)
                            }
                        }
                    )
            }
            if(router.method=="GET"){
                let httpParams = new HttpParams();
                if (params) {
                    for (const key in params) {
                      if (params[key] === false || params[key]) {
                        httpParams = httpParams.set(key, params[key]);
                      }
                    }
                  }

                this.http.get(router.url,{params:httpParams})
                    .subscribe(
                        res=>{
                            resolve(res)
                        },
                        err=>{
                            reject(err)
                        }
                    )
            }
            if(router.method=="PUT"){
                this.http.put(router.url,params)
                    .subscribe(
                        res=>{
                            resolve(res)
                        },
                        err=>{
                            reject(err)
                        }
                    )
            }
            if(router.method=="DELETE"){
                let param = new HttpParams
                param.set("orderId",params.orderId)
                let options = {
                    headers: new HttpHeaders({
                      'Content-Type': 'application/json',
                    }),
                    body: params,
                  };
                this.http.delete(router.url,options)
                    .subscribe(
                        res=>{
                            resolve(res)
                        },
                        err=>{
                            reject(err)
                        }
                    )
            }
        })
    }
}
